const SGDbankcardOptions = [
    {value: "PAYNOW", label: "PAYNOW"},
    {value: "POSB/DBS", label: "POSB/DBS"},
    {value: "OCBC", label: "OCBC"},
    {value: "UOB", label: "UOB"},
    {value: "SCB", label: "SCB"},
    {value: "HSBC", label: "HSBC"},
    {value: "MAYBANK", label: "MAYBANK"},
    {value: "CIMB", label: "CIMB"},
    {value: "BOC", label: "BOC"},
    {value: "ICBC", label: "ICBC"},
    {value: "GXS", label: "GXS"},
    {value: "TRUST", label: "TRUST"},
    {value: "MARIBANK", label: "MARIBANK"},
    {value: "RHB", label: "RHB"},
    {value: "CITIBANK", label: "CITIBANK"},
    {value: "HLB", label: "HLB"},
];

export default SGDbankcardOptions;
